module.exports = __webpack_public_path__ + "static/media/goldMedal.d30471a7.png";